module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            default header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printable"
    }
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("btn-confirm", [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-danger modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('confirmar')
      }
    }
  }, [_vm._v("\n              CONFIRMAR\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('cancelar')
      }
    }
  }, [_vm._v("\n              CANCELAR\n            ")])])]), _vm._v(" "), _vm._t("btn-msg", [_c('button', {
    staticClass: "btn btn-secondary modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_vm._v("\n              OK\n            ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe2ff02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Modal.vue
// module id = 1220
// module chunks = 1